var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalSpeakerSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 67,
    viewBox: "0 0 147 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.998 36.1671C146.998 53.1882 133.2 66.9865 116.179 66.9865C99.1575 66.9865 85.3591 53.1882 85.3591 36.1671C85.3591 19.146 99.1575 5.34766 116.179 5.34766C133.2 5.34766 146.998 19.146 146.998 36.1671Z",
    fill: "url(#paint0_linear_2_32164)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.678 38.7215C128.041 51.9651 114.857 59.4011 103.23 55.3302C91.603 51.2593 85.9365 37.2232 90.5734 23.9796C95.2103 10.736 108.395 3.30009 120.022 7.37097C131.649 11.4418 137.315 25.478 132.678 38.7215Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.425 36.5734C126.271 48.437 114.461 55.0981 104.045 51.4515C93.6301 47.8048 88.554 35.2312 92.7077 23.3676C96.8615 11.5041 108.672 4.84294 119.087 8.48962C129.503 12.1363 134.579 24.7099 130.425 36.5734Z",
    fill: "url(#paint1_linear_2_32164)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M121.866 31.5352C119.785 37.4801 113.866 40.8181 108.647 38.9907C103.428 37.1633 100.884 30.8626 102.966 24.9176C105.047 18.9727 110.966 15.6347 116.185 17.4621C121.404 19.2895 123.948 25.5902 121.866 31.5352Z",
    fill: "url(#paint2_linear_2_32164)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.77 18.6498C111.347 17.1012 106.058 19.8945 104.154 25.3337C102.25 30.7729 104.641 36.2552 109.064 37.8039C113.487 39.3525 118.776 36.5591 120.68 31.1199C122.585 25.6807 120.193 20.1984 115.77 18.6498ZM101.78 24.5023C104.038 18.0516 110.586 14.1691 116.602 16.2753C122.617 18.3814 125.313 25.5006 123.055 31.9513C120.796 38.402 114.248 42.2846 108.233 40.1784C102.217 38.0722 99.521 30.9531 101.78 24.5023Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.618 24.1266C118.273 26.0057 115.916 27.1474 113.353 26.6766C110.791 26.2059 108.993 24.301 109.339 22.4219C109.684 20.5428 112.041 19.4011 114.603 19.8719C117.166 20.3426 118.963 22.2475 118.618 24.1266Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.34 22.843C118.189 23.666 117.156 24.166 116.034 23.9598C114.912 23.7537 114.125 22.9194 114.276 22.0965C114.427 21.2736 115.46 20.7736 116.582 20.9797C117.704 21.1859 118.491 22.0201 118.34 22.843Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000164032 36.1671C-0.000164032 53.1882 13.7827 66.9865 30.7848 66.9865C47.7869 66.9865 61.5698 53.1882 61.5698 36.1671C61.5698 19.146 47.7869 5.34766 30.7848 5.34766C13.7827 5.34766 -0.000164032 19.146 -0.000164032 36.1671Z",
    fill: "url(#paint3_linear_2_32164)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3019 38.7216C18.9337 51.9651 32.1034 59.4011 43.7173 55.3302C55.3312 51.2593 60.9914 37.2232 56.3596 23.9796C51.7279 10.736 38.5582 3.30009 26.9443 7.37097C15.3304 11.4418 9.67019 25.478 14.3019 38.7216Z",
    fill: "#3D3D3D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5551 36.5734C20.7042 48.437 32.5016 55.0981 42.9054 51.4515C53.3091 47.8048 58.3795 35.2312 54.2304 23.3676C50.0813 11.5041 38.2839 4.84294 27.8801 8.48962C17.4764 12.1363 12.406 24.7099 16.5551 36.5734Z",
    fill: "url(#paint4_linear_2_32164)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.1039 31.5352C27.1831 37.4801 33.0949 40.8181 38.3083 38.9907C43.5217 37.1633 46.0625 30.8626 43.9834 24.9176C41.9042 18.9727 35.9924 15.6347 30.779 17.4621C25.5656 19.2895 23.0248 25.5902 25.1039 31.5352Z",
    fill: "url(#paint5_linear_2_32164)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1928 18.6498C35.6109 17.1012 40.8938 19.8945 42.796 25.3337C44.6983 30.7729 42.3098 36.2552 37.8917 37.8039C33.4736 39.3525 28.1907 36.5591 26.2885 31.1199C24.3862 25.6807 26.7747 20.1984 31.1928 18.6498ZM45.1679 24.5023C42.9119 18.0516 36.3711 14.1691 30.3624 16.2753C24.3536 18.3814 21.6605 25.5006 23.9166 31.9513C26.1726 38.402 32.7134 42.2846 38.7221 40.1784C44.7309 38.0722 47.424 30.9531 45.1679 24.5023Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.3491 24.1266C28.6939 26.0057 31.0484 27.1474 33.6079 26.6766C36.1674 26.2059 37.9628 24.301 37.618 22.4219C37.2732 20.5428 34.9187 19.4011 32.3592 19.8719C29.7997 20.3426 28.0043 22.2475 28.3491 24.1266Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.6268 22.843C28.7778 23.666 29.8089 24.166 30.9298 23.9598C32.0508 23.7537 32.837 22.9194 32.686 22.0965C32.535 21.2736 31.5039 20.7736 30.383 20.9797C29.2621 21.1859 28.4758 22.0201 28.6268 22.843Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_32164",
    x1: 116.179,
    y1: 5.34766,
    x2: 116.179,
    y2: 66.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_32164",
    x1: 119.087,
    y1: 8.48962,
    x2: 104.045,
    y2: 51.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_32164",
    x1: 116.185,
    y1: 17.4621,
    x2: 108.647,
    y2: 38.9907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B993",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_32164",
    x1: 30.7848,
    y1: 5.34766,
    x2: 30.7848,
    y2: 66.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_32164",
    x1: 27.8801,
    y1: 8.48962,
    x2: 42.9353,
    y2: 51.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_32164",
    x1: 30.779,
    y1: 17.4621,
    x2: 38.3233,
    y2: 38.9854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B993",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB086"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalSpeakerSystem);
export default __webpack_public_path__ + "static/media/ExternalSpeakerSystem.b51a8af9551a264cf3b080822259459f.svg";
export { ForwardRef as ReactComponent };